import { gql } from '@apollo/client';

export const MUTATION_UPDATE_USER = gql`
  mutation updateUsersPermissionsUser($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          updatedAt
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_WEEKLY = gql`
  mutation updateUserOnboardingWeeklyQuestions($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          onboardQuestionsCompleted
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_TRACKING = gql`
  mutation updateUserTracking($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          isEmotionWheelTrackingDisabled
        }
      }
    }
  }
`;
